import { UnitsManagementConst } from '@featureModule/units-management/consts';

/**
 * Constants for the Unit Types sub-module within Units Management.
 * Provides route paths, translation keys, child page routes,
 * and API endpoint placeholders.
 */
export abstract class UnitTypesConst {

    /**
     * The display title for the Unit Types module.
     */
    public static readonly TITLE = 'Unit Types';

    /**
     * The i18n translation key for the Unit Types sub-module.
     */
    public static readonly TRANSLATE_KEY = UnitsManagementConst.CHILDREN.UNIT_TYPES.TRANSLATE_KEY();

    /**
     * The breadcrumb translation key for the Unit Types module.
     */
    public static readonly BREADCRUMB = UnitsManagementConst.CHILDREN.UNIT_TYPES.BREADCRUMB();

    /**
     * The URL route segment for the Unit Types module.
     */
    public static readonly ROUTE_PAGE = UnitsManagementConst.CHILDREN.UNIT_TYPES.ROUTE_PAGE;

    /**
     * The full absolute route link for the Unit Types module.
     */
    public static readonly ROUTE_LINK = UnitsManagementConst.CHILDREN.UNIT_TYPES.ROUTE_LINK();

    /** Base API endpoint prefix for Unit Types requests. */
    public static readonly API_PREFIX_ENDPOINT = 'units/types';

    /** GET all unit types. */
    public static readonly LIST_ENDPOINT      = UnitTypesConst.API_PREFIX_ENDPOINT;

    /** POST create a new unit type. */
    public static readonly CREATE_ENDPOINT    = UnitTypesConst.API_PREFIX_ENDPOINT;

    /** GET a single unit type by ID. */
    public static readonly GET_BY_ID_ENDPOINT = (id: string): string => `${UnitTypesConst.API_PREFIX_ENDPOINT}/${id}`;

    /** PUT update a unit type by ID. */
    public static readonly UPDATE_ENDPOINT    = (id: string): string => `${UnitTypesConst.API_PREFIX_ENDPOINT}/${id}`;

    /** DELETE a unit type by ID. */
    public static readonly DELETE_ENDPOINT    = (id: string): string => `${UnitTypesConst.API_PREFIX_ENDPOINT}/${id}`;

    /**
     * Child page configurations for the Unit Types module.
     */
    public static readonly CHILDREN = {

        /**
         * The list page for Unit Types — displays the data table.
         */
        LIST: {
            NAME: 'LIST',
            TITLE: 'Unit Types List',
            ROUTE_PAGE: 'list',
            ROUTE_LINK: function () {
                return [UnitTypesConst.ROUTE_LINK, this.ROUTE_PAGE].join('/');
            },
        },

    };

}
